﻿import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function PageSkeleton() {
  return (
    <Stack spacing={2} sx={{ width: '100%', p: { xs: 2, md: 3 } }}>
      <Skeleton variant="text" width={180} height={40} />
      <Card variant="outlined">
        <CardContent>
          <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'wrap' }}>
            <Skeleton variant="rounded" width={110} height={40} />
            <Skeleton variant="rounded" width={170} height={40} />
            <Skeleton variant="rounded" width={140} height={40} />
          </Stack>
        </CardContent>
      </Card>
      <Card variant="outlined">
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}><Skeleton variant="rounded" height={52} /></Grid>
            <Grid size={{ xs: 12, md: 3 }}><Skeleton variant="rounded" height={52} /></Grid>
            <Grid size={{ xs: 12, md: 3 }}><Skeleton variant="rounded" height={52} /></Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 2.5 }}>
          <Card variant="outlined"><CardContent><Stack spacing={1.25}>{[1,2,3,4,5].map((item)=><Skeleton key={item} variant="rounded" height={44} />)}</Stack></CardContent></Card>
        </Grid>
        <Grid size={{ xs: 12, lg: 9.5 }}>
          <Card variant="outlined">
            <CardContent>
              <Stack spacing={2}>
                <Skeleton variant="text" width={220} height={36} />
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
                  {[1,2,3,4,5,6].map((item)=><Skeleton key={item} variant="rounded" height={52} />)}
                </Box>
                <Skeleton variant="rounded" height={120} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}
